import { CloseOutlined } from "@ant-design/icons"
import { Button, Modal, Form, Input, Collapse, Typography, Divider, ConfigProvider, Pagination, PaginationProps, } from "antd"


import '../../../../styles.scss'
import { avatar, avatarDefault } from "../../../../../../components/ExportImgFigma";
import { addCustomerComplaintLogs, getListCustomerComplaintLogs, IComplaintDetail, IListCustomerComplaintLogs } from "../../../../../../api/Customer_V2/customerApi_V2";
import { NO_DATA } from "../../../../../../services/data";
import viVN from 'antd/locale/vi_VN';
import { useEffect, useState } from "react";
import { formatNumber } from "../../../../../../services/mixin";
import { dataPagination, formatDateToDMY } from "../../../../../../until";
import useLoading from "../../../../../../hook/useLoading";
import useToast from "../../../../../../hook/useToast";
import useThrottle from "../../../../../../hook/useThrottle";

const { TextArea } = Input;
const { Text } = Typography;

interface ModalProps {
    isOpen: boolean
    idCustomer?: number
    infoSupportHistoryDetail?: IComplaintDetail
    closeModal: (isOpen: boolean) => void
}
const ModalDetailSupportHistory: React.FC<ModalProps> = ({
    isOpen, idCustomer, infoSupportHistoryDetail,
    closeModal
}) => {

    const pushLoading = useLoading()
    const pushToast = useToast();

    const [pagination, setPagination] = useState({ current: 1, pageSize: 20, total: 0 });

    const [dataListCustomerComplaintLogs, setDataListCustomerComplaintLogs] = useState<IListCustomerComplaintLogs[]>();
    const [valueDes, setValueDes] = useState<string>();


    const {
        id, adminId, adminName, categoryTitle, carLineTitle, chanelFbName,
        complainName, branchName, carName, chassisNo,
        complainDesc, complaintType1Desc, docDate, docDateEndProc,
        docResultName, docStatusEndName, interactionCategory, docCode,
        nextProcessDate, note, plateNumber, processLevel,
        regionName, solution, suspendReason
    } = infoSupportHistoryDetail ?? {}

    const formatLabel = (value: string): string => {
        return value
            .replace(/-\d+(?=\||$)/g, "")
            .replace(/\|/g, " / ");
    };

    const gListCustomerComplaintLogs = async (pageCurent: number = 1, pageSize: number = 20) => {
        // if (!infoCustomer?.id) return
        pushLoading(true)
        const result = await getListCustomerComplaintLogs(
            pageSize, pageCurent, idCustomer, id
        )
        if (result?.status) {
            setDataListCustomerComplaintLogs(result.data)
            setPagination({ current: pageCurent, total: result.total, pageSize: pageSize })
        } else {
            pushToast(result?.message, "warning")
        }
        pushLoading(false)
    }

    const onPaginationChange: PaginationProps['onChange'] = (pageNumber, pageSize) => {
        gListCustomerComplaintLogs(pageNumber, pageSize)
    }

    // chặn spam
    const handleAddCustomerComplaintLogs = useThrottle(async () => {
        // const valueDesTmp = valueDes?.trim()

        if (!idCustomer || !id || !adminId || !valueDes) {
            pushToast("Vui lòng nhập nội dung", 'warning');
            return;
        }
        pushLoading(true)
        const result = await addCustomerComplaintLogs(
            idCustomer, id, adminId, valueDes
        )
        if (result?.status) {
            setValueDes('')
            gListCustomerComplaintLogs()
        } else {
            pushToast(result?.message, "warning")
        }
        pushLoading(false)
    }, 1000)

    useEffect(() => {
        if (id) {
            gListCustomerComplaintLogs()
        }
    }, [id])

    useEffect(() => {
        if (isOpen) {
            setValueDes('')
        }
    }, [isOpen])

    return (
        <Modal
            title={<div className="bg-FCFCFD d-flex justify-betweeen align-center pb-4  w-full border-b-F0F0F0 rounded-2 overflow-hidden">
                <span className="text-base text-344054 fw-500 font-medium">Ghi chú thông tin hỗ trợ, khiếu nại</span>
                <CloseOutlined className="text-base text-8B8B8B" onClick={() => closeModal(false)} />
            </div>}
            open={isOpen}
            onCancel={() => closeModal(false)}
            centered
            className=" custom-modal-ant-history"
            closeIcon={false}
            footer={''}
            destroyOnClose
        >
            <div className="custom-modal-ant-history-child custom-page-css flex flex-col max-h-65vh overflow-y-scroll  ">
                <Collapse
                    defaultActiveKey={['general', 'car', 'support']}
                    ghost
                    expandIconPosition="end"
                >
                    {/* ================= Thông tin chung ================= */}
                    <Collapse.Panel
                        header={
                            <span className="text-base text-344054 fw-500 font-medium">Thông tin chung</span>
                        }
                        key="general"
                    >
                        <div className="grid grid-cols-2  gap-2">
                            <InfoItem
                                label="Loại tương tác"
                                value={docCode}
                            />
                            <InfoItem
                                label="Phân loại liên hệ"
                                value={interactionCategory}
                            />
                            <InfoItem
                                label="Ngày ghi nhận"
                                value={formatDateToDMY(docDate)}
                            />
                            <InfoItem
                                label="Kênh tiếp nhận"
                                value={chanelFbName}
                            />

                            <InfoItem
                                label="Ngày kết thúc"
                                value={formatDateToDMY(docDateEndProc)}
                            />
                        </div>
                        <div className="grid grid-cols-2  gap-2 pt-2">
                            <InfoItem
                                label="Trạng thái kết thúc xử lý"
                                value={docStatusEndName}
                            />
                            <InfoItem
                                label="Kết quả xử lý"
                                value={docResultName}
                            />
                        </div>

                    </Collapse.Panel>

                    {/* ================= Thông tin xe ================= */}
                    <Collapse.Panel
                        header={
                            <span className="text-base text-344054 fw-500 font-medium">Thông tin xe</span>
                        }
                        key="car"
                    >
                        <div className="grid grid-cols-2 gap-2">
                            <div className="grid grid-cols-2 gap-2">
                                <InfoItem
                                    label="Dòng xe"
                                    value={carLineTitle}
                                />
                                <InfoItem
                                    label="Thương hiệu"
                                    value={categoryTitle}
                                />
                            </div>
                            <InfoItem
                                label="Tên xe"
                                value={carName}
                            />
                        </div>
                        <div className="grid grid-cols-2  gap-2 pt-2">
                            <InfoItem
                                label="Biển số xe"
                                value={plateNumber}
                            />
                            <InfoItem
                                label="Số khung"
                                value={chassisNo}
                            />
                        </div>
                    </Collapse.Panel>

                    {/* ================= Thông tin hỗ trợ, khiếu nại ================= */}
                    <Collapse.Panel
                        header={
                            <span className="text-base text-344054 fw-500 font-medium">Thông tin hỗ trợ, khiếu nại</span>
                        }
                        key="support"
                    >
                        <div className="grid  gap-2">
                            <InfoItem
                                label="Phân loại"
                                value={formatLabel(complainName ?? '')}
                            />
                        </div>
                        <div className="grid grid-cols-2 gap-2 pt-2">


                            <InfoItem
                                label="Nhân viên tiếp nhận"
                                value={adminName}
                            />
                            <InfoItem
                                label="Đơn vị chịu trách nhiệm"
                                value={branchName}
                            />

                            <InfoItem
                                label="Khu vực"
                                value={regionName}
                            />
                            <InfoItem
                                label="Cấp độ xử lý"
                                value={processLevel}
                            />
                        </div>

                        <Divider />

                        <div className="custom-page-css flex flex-col gap-2">
                            <Text className="text-gray-500 text-sm">Nội dung :</Text>
                            <div className="text-344054 leading-relaxed whitespace-pre-line">
                                {complainDesc}
                            </div>
                        </div>
                        <Divider />
                        <div className="grid grid-cols-1  gap-2 ">
                            <InfoItem
                                label="Giải pháp"
                                value={solution}
                            />
                            <InfoItem
                                label="Ghi chú"
                                value={note}
                            />
                            <InfoItem
                                label="Lý do treo"
                                value={suspendReason}
                            />
                            <InfoItem
                                label="Ngày xử lý tiếp theo"
                                value={formatDateToDMY(nextProcessDate)}
                            />
                        </div>
                        <div className="custom-page-css  w-full bg-f2f8fd rounded p-4 flex flex-col gap-3 mt-2">
                            {/* Title */}
                            <span className="text-4E7FFF font-medium text-sm">
                                Lịch sử xử lý
                            </span>
                            {/* Action */}
                            <div className="custom-page-css flex flex-col items-end gap-3 bg-white p-2">
                                <TextArea
                                    placeholder="Nhập nội dung xử lý, tình trạng hiện tại"
                                    rows={4}
                                    className="rounded-md border-none"
                                    value={valueDes}
                                    onChange={(e) => setValueDes(e.target.value)}
                                />

                                <Button type="primary" size="small" className="custom-page-css w-fit "
                                    disabled={!valueDes || !valueDes.trim()}
                                    onClick={handleAddCustomerComplaintLogs}
                                >
                                    Gửi
                                </Button>
                            </div>
                        </div>

                        {/* lịch sử cập nhật */}
                        <div className="custom-page-css flex flex-col justify-between  h-full">

                            <div className="activity-timeline">

                                {
                                    dataListCustomerComplaintLogs?.map((item, i) => {
                                        const { dateCreate, description, adminCode, adminName, adminEmail } = item
                                        const [date, time] = dateCreate.split(" ")
                                        return (
                                            <div
                                                className={`timeline-item2 `}
                                                key={i}
                                            // className={`timeline-item ${i === activities.length - 1 ? "is-last" : ""}`}
                                            >
                                                {/* Line trong item */}


                                                {/* Cột thời gian */}
                                                <div className="timeline-time">
                                                    <Text>{date}</Text> <br />
                                                    <Text> {time} </Text>
                                                </div>


                                                {/* Nội dung */}
                                                <div className="timeline-content">
                                                    <div className="timeline-user">
                                                        <Text>{adminName} </Text>
                                                        <span className="cl096DD9 mr-4px">
                                                            {adminCode ? `(${adminCode})` : ''}
                                                        </span>
                                                        {/* <Text type="secondary">| {admin.}</Text> */}
                                                    </div>
                                                    <div className="timeline-email">{adminEmail}</div>

                                                    <div className="group-timeline-action">
                                                        <div className="text-344054 leading-relaxed whitespace-pre-line">
                                                            {description}
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                            {
                                dataListCustomerComplaintLogs?.length ?
                                    <ConfigProvider locale={viVN}>
                                        <div className="pagination-block">
                                            <Pagination
                                                className='rs-pagination'
                                                showSizeChanger
                                                current={pagination.current}
                                                pageSize={pagination.pageSize}
                                                total={pagination.total}
                                                pageSizeOptions={['10', '20', '50', '100']}
                                                itemRender={(page, type, originalElement) => {
                                                    // Chỉ custom khi là nút số trang
                                                    if (type === 'page') {
                                                        return <span>{formatNumber(page)}</span>;
                                                    }
                                                    // prev / next / jump-prev / jump-next giữ nguyên
                                                    return originalElement;
                                                }}
                                                showTotal={(total) => `Tổng cộng ${dataPagination(pagination.total, pagination.pageSize, pagination.current).totalPage} trang`}
                                                onChange={onPaginationChange}
                                            />
                                        </div>
                                    </ConfigProvider>
                                    : ''
                            }
                        </div>
                    </Collapse.Panel>
                </Collapse>
            </div>
        </Modal>
    )
}
export default ModalDetailSupportHistory

const InfoItem = ({ label, value }: { label: string; value?: string }) => (
    <div className="custom-page-css flex flex-col gap-1">
        <Text className="text-gray-500 text-sm">{label} :</Text>
        <Text className="text-344054 pl-3">
            {value || NO_DATA}
        </Text>
    </div>
);